export enum CoatingTypeEnum {
    Unknown,
    StainlessSteel,
    Epoxy,
    Zink,
    MarineLine,
}
